import { useEffect, useState } from "react";
import { resolveExpensesOwner } from "../services/statementVaultService";

/**
 * ¿La persona conectada es dueña (#1027)? `null` mientras el servidor no
 * responde. Solo decide qué se OFRECE: el control real es el 403 del servidor.
 */
export function useExpensesOwner(enabled = true): boolean | null {
  const [owner, setOwner] = useState<boolean | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    void resolveExpensesOwner().then((v) => alive && setOwner(v));
    return () => {
      alive = false;
    };
  }, [enabled]);
  return owner;
}
